import './styles.css';

import React, { useState } from 'react';
import { Slide, Button, Grid, Typography } from '@material-ui/core';
import { isMobile } from 'utils';
import { connect } from 'react-redux';
import { COOKIE_DOMAIN } from 'settings';

interface IProps {
  auth: any;
}

const AppRecomendation = ({ auth }: IProps) => {
  const [isShowing, setShowing] = useState(true);

  const dismissRecomendation = () => {
    setShowing(false);
  };

  const redirectToStore = () => {
    window.location.href = isMobile.iOS() ? process.env.REACT_APP_APP_STORE_URL : process.env.REACT_APP_GOOGLE_PLAY_URL;
  };

  const isCustomDomain = !window.location.hostname.endsWith(COOKIE_DOMAIN);

  if (isCustomDomain || !auth?.isAuthenticated) {
    return null;
  }

  return (
    <Slide direction='up' in={isShowing} mountOnEnter unmountOnExit>
      <Grid container direction='column' className='app-recomendation-root' spacing={2}>
        <Grid item>
          <Typography variant='h5'>Baixe o app agora mesmo para uma melhor experiência.</Typography>
        </Grid>
        <Grid container item spacing={2}>
          <Grid item xs={6}>
            <Button fullWidth onClick={dismissRecomendation} variant='outlined' color='primary'>
              Agora não
            </Button>
          </Grid>
          <Grid item xs={6}>
            <Button fullWidth onClick={redirectToStore} variant='contained' color='primary'>
              Baixar
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </Slide>
  );
};

const mapStateToProps = (state: any) => ({
  auth: state.auth,
});

export default connect(mapStateToProps)(AppRecomendation);
